import React, {Component} from 'react';
import {DetailContainer} from '../DetailContainer';
import {Form, Input, Label, ListGroup, ListGroupItem} from 'reactstrap';
import * as customers from 'customers/actions/customers';
import {connect} from 'react-redux';
import Loading from 'apa/components/Loading';
import autobind from 'autobind-decorator';

const REPORT_TYPES = [
    'Begehungsbericht',
    'Gefährdungsbeurteilung'
];

@connect(
    state => (
        {
            auth: state.apa
        }
    ),
    dispatch => {
        return {
            fetchCustomer: (customer_id, callback) => {
                dispatch(customers.fetchCustomer(customer_id, callback))
            }
        }
    }
)
export default class NewReport extends Component {

    constructor(props) {
        super(props);

        this.state = {
            customer: null,
            searchText: '',
            report: {
                customer: this.props.match.params.id,
                name: '',
                manual_type: 0,
                sector: '',
                categories: new Set([])
            },
            isLoading: false,
            categoryList: [],
            categoryListLoaded: false
        }
    }

    @autobind
    fetchCategories() {
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': `Token ${this.props.auth.token}`
        };

        fetch(
            '/api/categories/',
            {headers}
        )
            .then(res => res.json())
            .then(categoryList =>
                this.setState({
                    categoryList: categoryList,
                    categoryListLoaded: true,
                })
            )
    }

    componentDidMount() {
        this.props.fetchCustomer(this.props.match.params.id,
            customer => {
                this.setState({
                        customer: customer,
                        isLoading: false
                    }
                )
                this.fetchCategories();
            }
        )
    }

    @autobind
    selectCategory(category) {
        const selectedCategories = new Set(this.state.report.categories);
        selectedCategories.has(category.id) ? selectedCategories.delete(category.id) : selectedCategories.add(category.id)

        this.setState({
            report: {
                ...this.state.report,
                categories: selectedCategories
            }
        })
    }

    @autobind
    changePage(page) {
        this.fetchCategories(page);
    }

    @autobind
    onSubmit(event) {
        event.preventDefault();
        if (this.state.report.categories.size === 0)
            return;
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': `Token ${this.props.auth.token}`
        };

        const report = {...this.state.report, categories: Array.from(this.state.report.categories)};
        console.log(report);
        const body = JSON.stringify(report);

        fetch(
            '/api/reports/',
            {headers, method: 'POST', body}
        )
            .then(res => res.json())
            .then(
                report => {
                    this.props.history.push(`/customer/${report.customer}/reports`)
                }
            )

    }

    @autobind
    setSearchText(searchText) {
        this.setState({searchText: searchText});
    }

    render() {
        const id = this.props.match.params.id;

        if (!this.state.categoryListLoaded)
            return <Loading/>;

        const {searchText, categoryList} = this.state;

        let filteredCategoryList;
        if(searchText) {
            filteredCategoryList = categoryList.filter(category => category.name.toLowerCase().indexOf(searchText.toLowerCase()) > -1)
        } else {
            filteredCategoryList = categoryList
        }


        return (
            <DetailContainer id={id}>
                <h1>{this.state.customer.name}</h1>
                <Form onSubmit={this.onSubmit}>
                    <Label>
                        Name
                    </Label>
                    <Input value={this.state.report.name} required
                           onChange={e => this.setState({report: {...this.state.report, name: e.target.value}})}/>
                    <Label>
                        Bereich
                    </Label>
                    <Input value={this.state.report.sector}
                           onChange={e => this.setState({report: {...this.state.report, sector: e.target.value}})}/>
                    <Label>
                        Art
                    </Label>
                    <Input type='select' value={this.state.report.manual_type}
                           onChange={e => this.setState({report: {...this.state.report, manual_type: e.target.value}})}>
                        {
                            REPORT_TYPES.map(
                                (type, index) => <option key={`report_type_${index}`} value={index}>{type}</option>
                            )
                        }
                    </Input>
                    <Label>
                        Kategorien
                    </Label>
                    <Input onChange={(e) => this.setSearchText(e.target.value)} placeholder="Suche"/>
                    <ListGroup className="category-list">
                        {
                            filteredCategoryList.map(
                                (category, index) =>
                                    <ListGroupItem
                                        action={true}
                                        key={`category_${category.id}`}
                                        active={this.state.report.categories.has(category.id)}
                                        onClick={() => this.selectCategory(category)}
                                    >
                                        {index + 1}. {category.name}
                                    </ListGroupItem>
                            )
                        }
                    </ListGroup>
                    <Input type='submit' className='btn btn-success' onSubmit={this.onSubmit} value={'Speichern'}/>
                </Form>
            </DetailContainer>
        )
    }
}
